import React from "react";
import { numberWithCommas } from "../../../utils/functionUtils";

const SalesBusinessReportTable = ({
  salesReportData,
}) => {
  let tableColumns = [];
  const totalKeys = {};

  salesReportData?.reduce((acc, current) => {
    const keys = Object.keys(current);
    for (var i in keys) {
      totalKeys[keys[i]] = 1;
    }
  }, totalKeys);

  var keys = Object.keys(totalKeys);
  for (var i in keys) {
    if(keys[i] !== 'Months' && keys[i] !== 'ClientName') {
      tableColumns.push({
        colName:  keys[i]?.replace(/([a-z0-9])([A-Z])/g, "$1 $2") 
      });
    }
  }
  
  return (
    <div className="mx-auto py-3 w-full">
      <table className="tableSalesReport">
        <tr>
          <th>CATEGORY</th>
          <th>MONTHS</th>
          <th>VOLUME</th>
        </tr>
        {tableColumns?.map((v, i) => {
          return <tr>
              <td>{v?.colName}</td>
              <td>{salesReportData?.[0]['Months']?.replace(/(.{2}$)/, '-$1')}</td>
              <td>{numberWithCommas(salesReportData?.[0][v?.colName?.replaceAll(' ', '')] || salesReportData?.[1][v?.colName?.replaceAll(' ', '')])}{v?.colName === 'Churn Rate' ? '%' : ''}</td>
            </tr> 
        })
        }
        
      </table>
    </div>
  );
};

export default SalesBusinessReportTable;
